// extracted by mini-css-extract-plugin
export var cardHeader = "_fc-1";
export var contentCard = "_fc-0";
export var headerActions = "_fc-3";
export var reorderHandle = "_fc-5";
export var titleArea = "_fc-2";
export var titleAreaWithHandle = "_fc-4";